import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { VideoSettingsData } from "userful-chronos-app-common-js/dist/models/config/advancedVideoSettings";

export interface IState {
    videoSettings: VideoSettingsData;
}

const initialState: IState = {
    videoSettings: undefined,
};

export const advancedSettings = createSlice({
    name: "advancedSettingsSlice",
    initialState,
    reducers: {
        setVideoSettings: (state: IState, action: PayloadAction<VideoSettingsData>) => {
            state.videoSettings = { ...action.payload };
        },
    },
});

export const advancedSettingsActions = advancedSettings.actions;

export default advancedSettings.reducer;
